import { IBluetoothPermissionLabelSetting, ICommonSettings, ILanguageModel } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { IWithSDProps } from "../../../../../shared/hoc/screen-design-consumer";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigBluetoothSettings } from "./app-settings-config-bluetooth";

export interface IConfigBluetoothInputState {
  showModal: boolean;
  editingBluetoothId: string;
}

export interface IConfigBluetoothInputProps {
  parentData: string;
  commonSettings: ICommonSettings;
  languages: ILanguageModel[];
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigBluetoothInput extends PureComponent<IConfigBluetoothInputProps, IConfigBluetoothInputState> {
  formInputName = ["", "bluetoothPermissionLabelSettingsId"];

  constructor(props: IConfigBluetoothInputProps & IWithSDProps) {
    super(props);
    this.formInputName[0] = props.parentData;
    this.state = {
      showModal: false,
      editingBluetoothId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingBluetoothId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingBluetooth = (id: string) => {
    this.setState({ editingBluetoothId: id, showModal: true });
  };

  render() {
    const options = [
      {
        id: null,
        name: "Default"
      } as unknown as IBluetoothPermissionLabelSetting,
      ...(this.props.commonSettings.bluetoothPermissionLabelSettings || [])
    ];

    return (
      <>
        <ConfigBluetoothSettings
          formInputName={this.formInputName}
          showModal={this.state.showModal}
          closeModal={() => {
            this.closeModal();
          }}
          editingBluetoothId={this.state.editingBluetoothId}
          languages={this.props.languages}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={
            this.props.parentData === "androidConfig"
              ? "android_bluetooth_configuration"
              : "ios_bluetooth_configuration"
          }
          onAddNew={this.openModal}
          onEdit={this.setEditingBluetooth}
          dropdownTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_bluetooth_configuration"
              : "ios_bluetooth_configuration"
          }DropdownButton`}
          addNewTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_bluetooth_configuration"
              : "ios_bluetooth_configuration"
          }AddNewButton`}
          editTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_bluetooth_configuration"
              : "ios_bluetooth_configuration"
          }EditButton`}
        />
      </>
    );
  }
}
